"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function RealResults() {
  const header = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const photos = [{
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700144/img/kira_strength_training_focus.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700144/img/kira_strength_training_focus.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700144/img/kira_strength_training_focus.webp-wvc-sizes",
    alt: "Coach Kira demonstrating proper lifting technique",
    stamp: "FORM · PRECISION",
    coords: "LOG 02.11.2024",
    rotate: "-6deg",
    span: "col-span-2 md:col-span-6 row-span-2 aspect-[3/4]",
    corner: "top-3 right-3"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700144/img/kira_gym_equipment_wall.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700144/img/kira_gym_equipment_wall.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700144/img/kira_gym_equipment_wall.png-wvc-sizes",
    alt: "Organized gym equipment and kettlebells",
    stamp: "ARCHIVE · GEAR 02",
    coords: "LOG 01.22.2024",
    rotate: "4deg",
    span: "col-span-1 md:col-span-3 aspect-square",
    corner: "bottom-3 left-3"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700144/img/kira_client_deadlift_progress.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700144/img/kira_client_deadlift_progress.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700144/img/kira_client_deadlift_progress.png-wvc-sizes",
    alt: "Client performing a deadlift with perfect form",
    stamp: "POWER · LIFT",
    coords: "LOG 03.04.2024",
    rotate: "-3deg",
    span: "col-span-1 md:col-span-3 aspect-square",
    corner: "top-3 left-3"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700144/img/kira_nutrition_tracking_app.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700144/img/kira_nutrition_tracking_app.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700144/img/kira_nutrition_tracking_app.png-wvc-sizes",
    alt: "Kira reviewing nutritional progress on a tablet",
    stamp: "FUEL · DATA",
    coords: "LOG 02.28.2024",
    rotate: "5deg",
    span: "col-span-1 md:col-span-3 row-span-2 aspect-[3/4]",
    corner: "bottom-3 right-3"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700144/img/kira_coaching_studio_sign.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700144/img/kira_coaching_studio_sign.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700144/img/kira_coaching_studio_sign.png-wvc-sizes",
    alt: "Coach Kira Fit studio entrance sign",
    stamp: "EST. 2020",
    coords: "LOG 04.09.2024",
    rotate: "-5deg",
    span: "col-span-1 md:col-span-3 aspect-square",
    corner: "top-3 right-3"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700144/img/kira_recovery_zone_setup.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700144/img/kira_recovery_zone_setup.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700144/img/kira_recovery_zone_setup.png-wvc-sizes",
    alt: "Dedicated recovery and stretching area",
    stamp: "RECOVERY · 04",
    coords: "LOG 03.18.2024",
    rotate: "3deg",
    span: "col-span-1 md:col-span-3 aspect-square",
    corner: "bottom-3 left-3"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700144/img/kira_community_fitness_group.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700144/img/kira_community_fitness_group.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700144/img/kira_community_fitness_group.png-wvc-sizes",
    alt: "Group fitness session led by Coach Kira",
    stamp: "COMMUNITY · FIT",
    coords: "LOG 05.01.2024",
    rotate: "-4deg",
    span: "col-span-2 md:col-span-6 row-span-2 aspect-[3/4]",
    corner: "top-3 left-3"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700144/img/kira_functional_movement_drill.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700144/img/kira_functional_movement_drill.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700144/img/kira_functional_movement_drill.png-wvc-sizes",
    alt: "Close-up of functional movement training",
    stamp: "DRILL · CORE",
    coords: "LOG 04.22.2024",
    rotate: "6deg",
    span: "col-span-1 md:col-span-4 aspect-square",
    corner: "top-3 right-3"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700144/img/kira_supplement_hydration_station.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700144/img/kira_supplement_hydration_station.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700144/img/kira_supplement_hydration_station.png-wvc-sizes",
    alt: "Hydration and supplement station for clients",
    stamp: "FUEL · HYDRATE",
    coords: "LOG 05.14.2024",
    rotate: "-7deg",
    span: "col-span-1 md:col-span-4 aspect-square",
    corner: "bottom-3 right-3"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700144/img/kira_training_log_notebook.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700144/img/kira_training_log_notebook.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700144/img/kira_training_log_notebook.png-wvc-sizes",
    alt: "Detailed training log and progress notes",
    stamp: "LOG · 07",
    coords: "LOG 06.02.2024",
    rotate: "2deg",
    span: "col-span-1 md:col-span-4 aspect-square",
    corner: "bottom-3 left-3"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700144/img/kira_morning_training_session.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700144/img/kira_morning_training_session.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700144/img/kira_morning_training_session.png-wvc-sizes",
    alt: "Early morning training session in the studio",
    stamp: "DAWN · 06:00",
    coords: "LOG 06.19.2024",
    rotate: "-5deg",
    span: "col-span-1 md:col-span-3 aspect-[3/4]",
    corner: "top-3 left-3"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700144/img/kira_studio_exterior_view.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700144/img/kira_studio_exterior_view.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700144/img/kira_studio_exterior_view.png-wvc-sizes",
    alt: "Exterior view of the Coach Kira Fit studio",
    stamp: "STUDIO · EXTERIOR",
    coords: "LOG 06.27.2024",
    rotate: "4deg",
    span: "col-span-1 md:col-span-3 aspect-[3/4]",
    corner: "bottom-3 right-3"
  }];
  return <section data-section-id="1411" id="real-results" className="dark bg-background text-foreground py-28 md:py-40 relative overflow-hidden">
      <style>{`
        @keyframes stamp-breathe {
          0%, 100% { transform: rotate(var(--stamp-rotate)) scale(1); }
          50% { transform: rotate(calc(var(--stamp-rotate) + 1.5deg)) scale(1); }
        }
        .stamp-idle { animation: stamp-breathe 6s ease-in-out infinite; }
        .photo-card:hover .stamp-idle {
          animation: none;
          transform: rotate(calc(var(--stamp-rotate) + 4deg));
          transition: transform 320ms cubic-bezier(0.22, 1, 0.36, 1);
        }
        .photo-img {
          transition: transform 320ms cubic-bezier(0.22, 1, 0.36, 1);
        }
        .photo-card:hover .photo-img {
          transform: scale(1.04);
        }
        .reveal {
          opacity: 0;
          transform: translateY(16px);
          transition: opacity 700ms cubic-bezier(0.22, 1, 0.36, 1), transform 700ms cubic-bezier(0.22, 1, 0.36, 1);
        }
        .reveal.is-visible {
          opacity: 1;
          transform: translateY(0);
        }
      `}</style>

      <div aria-hidden="true" className="pointer-events-none absolute inset-0 opacity-[0.06]" style={{
      backgroundImage: "repeating-radial-gradient(circle at 20% 30%, var(--foreground) 0, var(--foreground) 1px, transparent 1px, transparent 60px), repeating-radial-gradient(circle at 80% 70%, var(--foreground) 0, var(--foreground) 1px, transparent 1px, transparent 80px)"
    }} />

      <div className="relative mx-auto max-w-[1360px] px-6 md:px-10">
        <div ref={header.ref} className={`reveal ${header.isVisible ? "is-visible" : ""} grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-12 mb-16 md:mb-24`}>
          <div className="md:col-span-5">
            
            <h2 className="font-sans font-default text-foreground" style={{
            fontSize: "clamp(2.25rem, 4.5vw, 4.5rem)",
            fontWeight: 700,
            letterSpacing: "-0.02em",
            lineHeight: 1.02
          }}>
              Evidence of{" "}
              <em className="font-sans italic font-normal" style={{
              color: "var(--primary)"
            }}>
                progress
              </em>
              .
            </h2>

            <div className="mt-10 flex items-center gap-3">
              <div className="h-px flex-1 bg-foreground/40" />
              <div className="w-1.5 h-1.5 rounded-lg" style={{
              background: "var(--primary)"
            }} />
            </div>
          </div>

          <div className="md:col-span-7 flex flex-col md:items-end md:text-right justify-between gap-6">
            
            <p className="font-mono text-xs md:text-sm max-w-sm opacity-80 leading-relaxed" style={{
            letterSpacing: "0.04em"
          }}>
              Visual documentation of client transformations and training milestones.
              <br />
              Captured at the Coach Kira Fit studio.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-12 gap-3 md:gap-4 auto-rows-auto">
          {photos.map((photo, i) => {
          const reveal = useRevealOnScroll<HTMLDivElement>({
            threshold: 0.15
          });
          return <div key={i} data-index={i} ref={reveal.ref} className={`reveal ${reveal.isVisible ? "is-visible" : ""} ${photo.span} photo-card group relative overflow-hidden`} style={{
            transitionDelay: `${i % 4 * 80}ms`,
            background: "var(--card)",
            border: "1px solid var(--border)"
          }}>
                <div className="absolute inset-0 overflow-hidden">
                  <img src={photo.src} data-wvc-srcset={photo.srcset} data-wvc-sizes={photo.sizes} alt={photo.alt} loading="lazy" decoding="async" className="photo-img w-full h-full object-cover" style={{
                filter: "grayscale(0.8) contrast(1.1)"
              }} />
                  <div aria-hidden="true" className="absolute inset-0 mix-blend-multiply" style={{
                background: "linear-gradient(180deg, hsla(75, 100%, 50%, 0.15) 0%, hsla(240, 10%, 4%, 0.6) 100%)"
              }} />
                  <div aria-hidden="true" className="absolute inset-0 opacity-[0.08] pointer-events-none mix-blend-overlay" style={{
                backgroundImage: "repeating-conic-gradient(var(--foreground) 0% 0.0001%, transparent 0.0001% 0.0002%)",
                backgroundSize: "3px 3px"
              }} />
                </div>

                <div className={`absolute ${photo.corner} z-10 stamp-idle`} style={{
              ["--stamp-rotate" as string]: photo.rotate,
              transform: `rotate(${photo.rotate})`
            } as React.CSSProperties}>
                  <div className="relative flex items-center justify-center" style={{
                width: "84px",
                height: "84px"
              }}>
                    <svg viewBox="0 0 100 100" className="absolute inset-0 w-full h-full" aria-hidden="true">
                      <defs>
                        <filter id={`rough-${i}`}>
                          <feTurbulence type="fractalNoise" baseFrequency="0.9" numOctaves="2" />
                          <feDisplacementMap in="SourceGraphic" scale="1.5" />
                        </filter>
                      </defs>
                      <circle cx="50" cy="50" r="44" fill="none" stroke="var(--primary)" strokeWidth="2" filter={`url(#rough-${i})`} />
                      <circle cx="50" cy="50" r="36" fill="none" stroke="var(--primary)" strokeWidth="1" filter={`url(#rough-${i})`} />
                    </svg>
                    <div className="relative text-center px-2">
                      <div className="font-mono uppercase font-semibold leading-tight" style={{
                    color: "var(--primary)",
                    fontSize: "0.5rem",
                    letterSpacing: "0.1em"
                  }}>
                        {photo.stamp}
                      </div>
                      <div className="mt-1 w-4 h-px mx-auto" style={{
                    background: "var(--primary)"
                  }} />
                      <div className="font-mono uppercase mt-1" style={{
                    color: "var(--primary)",
                    fontSize: "0.4rem",
                    letterSpacing: "0.14em"
                  }}>
                        KIRA
                      </div>
                    </div>
                  </div>
                </div>

                <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4 z-10 flex items-end justify-between gap-2">
                  <div className="font-mono uppercase text-[0.6rem] md:text-[0.65rem] text-foreground/80" style={{
                letterSpacing: "0.12em"
              }}>
                    {photo.coords}
                  </div>
                  <div className="flex items-center gap-1.5">
                    <div className="h-px w-6 bg-foreground/40" />
                    <div className="w-1 h-1 rounded-lg" style={{
                  background: "var(--primary)"
                }} />
                  </div>
                </div>
              </div>;
        })}
        </div>

        <div className="mt-16 md:mt-24 flex items-center gap-3">
          <div className="font-mono uppercase text-xs opacity-70" style={{
          letterSpacing: "0.16em"
        }}>
            END OF LOG · 12 OF 12
          </div>
          <div className="h-px flex-1 bg-foreground/30" />
          <div className="w-1.5 h-1.5 rounded-lg" style={{
          background: "var(--primary)"
        }} />
        </div>
      </div>
    </section>;
}